<div class="container-fluid">
  <h4>{{'Calendar.header' | translate}}</h4>
  <p>{{'Calendar.shortDescription' | translate}}</p>
  <!--<div>
  <button mat-raised-button (click)="OnCreateHoliday()">
    <mat-icon>add</mat-icon> Create New Holiday
  </button>
</div>-->

<div class="mat-elevation-z8 mt-3">

  <div class="search-div">
    <mat-form-field class="search-form-field">
      <input matInput [(ngModel)]="searchKey" placeholder="{{'Calendar.plchldrSearchHoliday' | translate}}" autocomplete="off"
        (keyup)="ApplyFilter()">
        @if (searchKey) {
          <button mat-button matSuffix mat-icon-button aria-label="Clear"
            (click)="OnSearchClear()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
    <div class="scrollableTable">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows >

        <ng-container matColumnDef="actualDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Calendar.thActualDate' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.actualDate | date:"d MMM yyyy"}}</td>
        </ng-container>


        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumns.length" class="calendarCell">
            <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              @for (exception of element.exceptions; track exception) {
                <div >
                  <mat-label>{{exception}}</mat-label>
                </div>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="statutoryDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Calendar.thStatutoryDate' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.statutoryDate | date:"d MMM yyyy"}}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 40%;"> {{'Calendar.thPublicHoliday' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.description}}</td>
        </ng-container>

        <ng-container matColumnDef="exceptions">
          <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: right;"> {{'Calendar.thExceptions' | translate}}</th>
          <td mat-cell *matCellDef="let element"  style="text-align: right;">{{element.exceptions.length}}</td>
        </ng-container>

        <ng-container matColumnDef="loading">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
        </ng-container>

        <ng-container matColumnDef="noData">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Calendar.tblNoData' | translate}}... </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>

        <tr mat-row *matRowDef="let element; columns: displayColumns;" class="element-row"
          [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>

        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
        [ngClass]="{'hide':(dataSource!=null && holidaysLength != 0) || isLoading === true}"></tr>

      </table>
    </div>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" [length]="holidaysLength"></mat-paginator>
  </div>
</div>